import { Table, Checkbox, Button, Badge, Spin } from "antd";
import { FaTrash, FaFileAlt, FaFileExcel, FaFileWord } from "react-icons/fa";
import { useMemo } from "react";
import { v4 as uuidv4 } from "uuid";

export default function FileTable({
  files,
  loading,
  selectedFiles,
  toggleFileSelection,
  toggleAllFiles,
  onDeleteFile,
  hidePagination = false, 
}) {
  const getFileIcon = (nombre) => {
    const extension = nombre.split(".").pop()?.toLowerCase();
    let color = "#042956";

    if (extension === "pdf") return <FaFileAlt style={{ color, fontSize: 25 }} />;
    if (extension === "doc" || extension === "docx") return <FaFileWord style={{ color, fontSize: 25 }} />;
    if (extension === "xls" || extension === "xlsx") return <FaFileExcel style={{ color, fontSize: 25 }} />;
    return <FaFileAlt style={{ color, fontSize: 25 }} />;
  };

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString("es-ES", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

  const allSelected = files.length > 0 && files.every((f) => selectedFiles.has(f.ruta));

  const filesWithId = useMemo(
    () => files.map((f) => ({ ...f, _uid: f.ruta + "_" + uuidv4() })),
    [files]
  );

  const columns = [
    {
      title: <Checkbox checked={allSelected} onChange={toggleAllFiles} />,
      dataIndex: "checkbox",
      key: "checkbox",
      render: (_, record) => (
        <Checkbox
          checked={selectedFiles.has(record.ruta)}
          onChange={() => toggleFileSelection(record.ruta)}
        />
      ),
      width: 50,
    },
    {
      title: "Archivo",
      dataIndex: "nombre",
      width: 400,
      key: "nombre",
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div>{getFileIcon(record.nombre)}</div>
          <div style={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
            <span
              style={{
                fontWeight: "bold",
                fontSize: 14,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {record.nombre}
            </span>
            <span style={{ fontSize: 15, color: "#888" }}>
              {record.json?.user || "N/A"}
            </span>
          </div>
        </div>
      ),
    },
    {
      title: "Estado",
      dataIndex: ["json", "estado"],
      key: "estado",
       width: 150,
      align: "center",
      render: (text) => <Badge color="blue" text={text || "N/A"} />,
    },
    {
      title: "Fecha",
      dataIndex: ["json", "dateTime"],
      key: "dateTime",
      align: "center",
      width: 150,
      render: (text) => (text ? formatDate(text) : "N/A"),
    },
    {
      title: "Acciones",
      key: "acciones",
      align: "center",
      width: 150,
      render: (_, record) => (
        <Button
          type="text"
          danger
          size="small"
          onClick={() => onDeleteFile(record)}
        >
          <FaTrash />
          <span className="hidden sm:inline">Eliminar</span>
        </Button>
      ),
    },
  ];

  if (loading) {
    return (
      <div style={{ padding: 32, display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Spin size="large" />
        <p style={{ marginTop: 12, color: "#888" }}>Cargando archivos...</p>
      </div>
    );
  }

  return (
    <div style={{ borderRadius: 8, border: "1px solid #f0f0f0", overflowX: "auto" }}>
      {files.length === 0 ? (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: 32, color: "#888" }}>
          <FaFileAlt style={{ fontSize: 32, marginBottom: 8 }} />
          <p>No se encontraron archivos</p>
        </div>
      ) : (
        <Table
          dataSource={filesWithId}
          columns={columns}
          rowKey="_uid"
          pagination={hidePagination ? false : { 
            pageSize: 10,
            showSizeChanger: false,
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} archivos`,
          }}
          scroll={{ y: 500 }}
        />
      )}
    </div>
  );
}